//apifetch
import axios from "axios";

//translate
import i18n from "../../translate/i18n";

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;


export const GetSettings = async (params:string[]) => {
  const queryString = params
    .map((element, index) => `key[${index}]=${element}`)
    .join("&");
    const response = await axios.get(`${baseURL}/settings?${queryString}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": i18n.language,
      },
    });
    return response.data;
}